import { format, parse, isValid } from "date-fns";
import { de } from "date-fns/locale";

/** Return "TT/MM/JJJJ" from an ISO date string (YYYY-MM-DD or full ISO). */
export function fmtDateEU(iso) {
  if (!iso) return "";
  const s = String(iso).slice(0, 10);
  const d = parse(s, "yyyy-MM-dd", new Date());
  if (!isValid(d)) return String(iso);
  return format(d, "dd/MM/yyyy");
}

/** Return "Wochentag, TT/MM/JJJJ" (de-DE). */
export function fmtDateEULong(iso) {
  if (!iso) return "";
  const s = String(iso).slice(0, 10);
  const d = parse(s, "yyyy-MM-dd", new Date());
  if (!isValid(d)) return String(iso);
  return format(d, "EEEE, dd/MM/yyyy", { locale: de });
}

/** Return "TT/MM" short label for compact rows. */
export function fmtDateEUShort(iso) {
  if (!iso) return "";
  const s = String(iso).slice(0, 10);
  const d = parse(s, "yyyy-MM-dd", new Date());
  if (!isValid(d)) return String(iso);
  return format(d, "EEE dd/MM", { locale: de });
}

/** 24h HH:mm from Date-like or string; passes through when already HH:mm. */
export function fmtTime24(t) {
  if (!t) return "";
  if (typeof t === "string" && /^\d{2}:\d{2}/.test(t)) return t.slice(0, 5);
  const d = t instanceof Date ? t : new Date(t);
  if (isNaN(d)) return String(t);
  return d.toLocaleTimeString("de-DE", { hour: "2-digit", minute: "2-digit", hour12: false });
}

/** Current live wall clock (Europe locale) — HH:mm:ss. */
export function fmtClock(d = new Date()) {
  return d.toLocaleTimeString("de-DE", { hour: "2-digit", minute: "2-digit", second: "2-digit", hour12: false });
}
